(function ($) {

    $('.user-ratings__item').on('click', function () {
        if (!$(this).hasClass('active')) {
            const $content = $(this).find('.user-ratings__item-bottom');
            $('.user-ratings__item').removeClass('active');
            $(this).addClass('active');
            $('.user-ratings__item-bottom').slideUp(300);
            $content.slideDown(300);
        }
    });

    $('.user-ratings__item-top').on('click', function (e) {
        if ($(this).parent().hasClass('active')) {
            e.stopPropagation();
            const $content = $(this).parent().find('.user-ratings__item-bottom');
            $content.slideUp(300);
            $(this).parent().removeClass('active');
        }
    });

})(jQuery);